export class ListReceiptMoneyViewModel {
    id: number;
    fromHubId: number;
    toHubId: number;
    cancelReason: string;
    paidByEmpId: number;
    totalShipment: number;
    totalCOD: number;
    totalPrice: number;
    grandTotal: number;
    grandTotalReal: number;
    attachmentId: number;
    shipments: any[];
    note: string;
    bankAccount: string;
    paymentDate: Date;
    feeBank: number = 0;
    accountingAccountId: number;
    lockDate: any;
    acceptDate: any;
    warningNote: string;
    fromDate: any;
    toDate: any;
    searchText: any;
    pageNumber: number;
    pageSize: number;
    reasonListGoodsId: number;
    listReceiptMoneyId:number;
}
// export class ShipmentToReceipt
// {
//     id : number;
//     cOD: number;
//     totalPrice:number;
// }